import React, { useState, useEffect } from 'react';
import PureModal from 'react-pure-modal';
import 'react-pure-modal/dist/react-pure-modal.min.css';
import md5 from 'crypto-js/md5';


export default function FileModal({ modal_open, close_cb, ok_cb, attach_type })
{

    const initial_state = {
        data: 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
        name: '',
        title: '',
        md5: '',
        mime: ''
    }

    const [base64_file, set_base64_file] = useState(initial_state);

    const [add_btn_disabled, set_add_btn_disabled] = useState(true);

    const [error_text, set_error_text] = useState('');
    const [labels, set_labels] = useState({
        modal_label: '',
        btn_title: '',
        file_format: ''
    });

    const handleFileRead = async (event) =>
    {
        set_error_text('');
        const title = base64_file.title;
        let tmp = { ...initial_state, title };
        set_base64_file(tmp);
        set_add_btn_disabled(true);
        const file = event.target.files[0];
        if (file.size >= 5 * 1024 * 1024)
        {
            set_error_text('The file is too big');
        }
        else if ((file.type.indexOf('image') === -1) && attach_type === 'image')
        {
            set_error_text('Wrong File type');
        }
        else
        {
            const base64 = await convertBase64(file);
            set_base64_file({
                data: base64,
                name: file.name,
                title: base64_file.title,
                md5: md5(file.name).toString(),
                mime: file.type,
                attach_type: attach_type
            });
        }
        set_add_btn_disabled(false);
    };

    const convertBase64 = (file) =>
    {
        return new Promise((resolve, reject) =>
        {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = () =>
            {
                resolve(fileReader.result);
            }
            fileReader.onerror = (error) =>
            {
                reject(error);
            }
        })
    };

    const reset_state = () =>
    {
        set_base64_file(initial_state);
        set_add_btn_disabled(true);
        set_error_text('');
    };

    const handle_input = (evt) =>
    {
        const title = evt.target.value
        let tmp = { ...base64_file, title };
        set_base64_file(tmp);
    };

    const handle_abb_btn_click = (evt) =>
    {
        const tmp = base64_file;
        if(base64_file.title === '')
        {
            set_error_text('Title is required');
        }
        else
        {
            reset_state();
            ok_cb(evt, tmp);
        }
    };

    useEffect(() =>
    {
        if(attach_type === 'image')
        {
            set_labels(
                {
                    'modal_label': 'Upload an image',
                    'btn_title': 'Select an image',
                    'file_format': 'image/*'
                }
            );
        }
        else if(attach_type === 'attach')
        {
            set_labels(
                {
                    'modal_label': 'Upload a file',
                    'btn_title': 'Select a file',
                    'file_format': '*/*'
                }
            );
        }
        else
        {
            console.error('unsupported type');
            set_labels(
                {
                    'modal_label': '',
                    'btn_title': '',
                    'file_format': '*/*'
                }
            );
        }
    }, [attach_type]);

    return (
        <PureModal
            header={labels.modal_label}
            footer={
                <div>
                    <button onClick={evt =>
                    {
                        reset_state();
                        close_cb(evt);
                        return true;
                    }}>Cancel</button>
                    <button onClick={handle_abb_btn_click}
                        disabled={add_btn_disabled}
                    >Add</button>
                </div>
            }
            isOpen={modal_open}
            onClose={evt =>
            {
                reset_state();
                close_cb(evt);
                return true;
            }}
        >
            <p className='fileDialogBody'>
                <label htmlFor="title">Title:</label>
                <input type="text" className="form-control"
                    id="title"
                    value={base64_file.title}
                    onChange={handle_input}
                />
                <label className="btn btn-default" htmlFor="myfile">{labels.btn_title}</label>
                <input
                    className="btn btn-default"
                    style={{ visibility: 'hidden' }}
                    type="file"
                    id="myfile"
                    name="myfile"
                    inputprops={{ accept: 'image/*' }}
                    required
                    label="Images"
                    onChange={e => handleFileRead(e)}
                    size="small"
                    variant="standard"
                />
                <span>{base64_file.name}</span>
                <span className='error_msg'>{error_text}</span>
            </p>
        </PureModal>
    )
}